<div class="content">
  <div class="card">
    <div class="card-body text-center about-user">
      <p class="mt-3">Tell us more about yourself!</p>
      <h2 class="mt-3">Are you an Instagrammer or a marketer?</h2>
      <div class="options my-md-4">
        <a [ngClass]="{active: type === 2}" (click)="setType(2)">
          <img src="assets/images/building.png"/>
          <h5>Marketer</h5>
          <p>I work for a brand or agency</p>
        </a>
        <a [ngClass]="{active: type === 1}" (click)="setType(1)">
          <img src="assets/images/phone.png"/>
          <h5>Instagrammer</h5>
          <p>I have a profile on the Instagram</p>
        </a>
      </div>
      <div class="mb-4">
        <a (click)="setType(2)">Not sure (skip for now)</a>
      </div>
    </div>
  </div>
</div>
